'use strict';

const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const RelatedKeys = require('common/domain/value/related-keys');

module.exports = Backbone.Model.extend({
    defaults: {
        taskKey: null,
        projectKey: null,
        projectName: ''
    },

    done: function() {
        this.set('state', 'done');
    },

    isDone: function() {
        return this.get('state') === 'done';
    },

    getTaskKey: function() {
        return new Key(this.get('taskKey'));
    },

    getProjectKey: function() {
        return new Key(this.get('projectKey'));
    },

    getProjectName: function() {
        return this.get('projectName');
    },

    getProjectImageURL: function() {
        return this.get('projectImageURL');
    },

    getTaskURL: function() {
        const projectKey = this.getProjectKey();
        const taskKey = this.getTaskKey();
        return `/projects/${projectKey.id}#tasks/${taskKey.id}`
    },

    getProjectURL: function() {
        const projectKey = this.getProjectKey();
        return `/projects/${projectKey.id}`
    },

    getState: function() {
        return this.get('state');
    },

    getUpdatedAt: function() {
        return this.get('updatedAt');
    },

    isDeleted: function() {
        return false;
    },

    getRelatedKeys: function() {
        const keys = _.map(this.get('relatedKeys'), k => new Key(k));
        return new RelatedKeys(keys);
    },

    getPrimaryRelatedKey: function() {
        return this.getRelatedKeys().primaryKey;
    },
});



// WEBPACK FOOTER //
// ./my/domain/entity/task.js